module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wxShow),
      expression: "wxShow"
    }],
    staticClass: "wx-load-c",
    staticStyle: {
      "width": "100%",
      "height": "100"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin": "20px",
      "font-size": "30px",
      "cursor": "pointer"
    },
    attrs: {
      "type": "ios-close"
    },
    on: {
      "click": _vm.wxClose
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "login_container"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "reg-from"
  }, [_vm._m(1), _vm._v(" "), (_vm.op === 0 && _vm.wxBand == false) ? _c('div', {
    staticClass: "from-box",
    class: {
      'op': _vm.op === 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sign.phone),
      expression: "sign.phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.sign.phone)
    },
    on: {
      "blur": function($event) {
        return _vm.signPhone()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sign, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "from-warning",
    class: {
      'op1': _vm.op2 === true
    }
  }, [_vm._v("*请填写正确的手机号")]), _vm._v(" "), (!_vm.dx) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sign.psd),
      expression: "sign.psd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.sign.psd)
    },
    on: {
      "blur": function($event) {
        return _vm.signPsd()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sign, "psd", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.dx) ? _c('p', {
    staticClass: "from-warning",
    class: {
      'op1': _vm.op4 === true
    }
  }, [_vm._v("*密码错误")]) : _vm._e(), _vm._v(" "), (_vm.dx) ? _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sign.psd),
      expression: "sign.psd"
    }],
    staticClass: "yzm-ipt",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.sign.psd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sign, "psd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2),
      expression: "show2"
    }],
    staticClass: "get-yzm",
    on: {
      "click": function($event) {
        return _vm.signYzm()
      }
    }
  }, [_vm._v(_vm._s(_vm.yzm2))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show2),
      expression: "!show2"
    }],
    staticClass: "get-yzm"
  }, [_vm._v(_vm._s(_vm.count2) + "s")])]) : _vm._e(), _vm._v(" "), (_vm.dx) ? _c('p', {
    staticClass: "from-warning"
  }, [_vm._v("*验证码错误")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "height": "20px"
    }
  }, [(!_vm.dx) ? _c('Checkbox', [_vm._v("记住密码")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "color": "#5C8DDE",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.dxFrom()
      }
    }
  }, [_vm._v(_vm._s(_vm.txt))])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('button', {
    staticClass: "btn-sign",
    on: {
      "click": function($event) {
        return _vm.signIn()
      }
    }
  }, [_vm._v("登录")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "display": "none"
    }
  }, [_vm._v("or")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "14px",
      "color": "#323030",
      "opacity": "0.6",
      "padding": "10px 0"
    }
  }, [_vm._v("第三方登录")]), _vm._v(" "), _c('ul', {
    staticClass: "other-sign",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.wxLoad()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])]) : _vm._e(), _vm._v(" "), (_vm.op === 1 && _vm.wxBand == false) ? _c('div', {
    staticClass: "from-box",
    class: {
      'op': _vm.op !== 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reg.nickName),
      expression: "reg.nickName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入昵称"
    },
    domProps: {
      "value": (_vm.reg.nickName)
    },
    on: {
      "blur": function($event) {
        return _vm.regNC()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reg, "nickName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "from-warning",
    class: {
      'op1': _vm.op1 === true
    }
  }, [_vm._v("*请不要输入特殊字符或者为空")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reg.phone),
      expression: "reg.phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.reg.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reg, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "from-warning",
    class: {
      'op1': _vm.op2 === true
    }
  }, [_vm._v("*请填写正确的手机号")]), _vm._v(" "), (_vm.op === 1) ? _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reg.code),
      expression: "reg.code"
    }],
    staticClass: "yzm-ipt",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.reg.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reg, "code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show1),
      expression: "show1"
    }],
    staticClass: "get-yzm",
    on: {
      "click": function($event) {
        return _vm.getYzm()
      }
    }
  }, [_vm._v(_vm._s(_vm.yzm1))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show1),
      expression: "!show1"
    }],
    staticClass: "get-yzm"
  }, [_vm._v(_vm._s(_vm.count1) + "s")])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "from-warning"
  }, [_vm._v("*验证码错误")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reg.psd),
      expression: "reg.psd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.reg.psd)
    },
    on: {
      "blur": function($event) {
        return _vm.regPsd()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reg, "psd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "from-warning",
    class: {
      'op1': _vm.op4 === true
    }
  }, [_vm._v("*密码格式错误,请输入6-21位字母加数字密码")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "height": "20px",
      "padding-top": "10px"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.agr),
      callback: function($$v) {
        _vm.agr = $$v
      },
      expression: "agr"
    }
  }, [_vm._v("已阅读并接受 "), _c('a', {
    staticStyle: {
      "color": "#5C8DDE"
    },
    attrs: {
      "href": "agreement.html"
    }
  }, [_vm._v("《趣编网服务协议》")]), _c('a', {
    staticStyle: {
      "color": "#5C8DDE"
    },
    attrs: {
      "href": "policy.html"
    }
  }, [_vm._v("《趣编网隐私政策》")])])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "20px 0 0px 0"
    }
  }, [_c('button', {
    staticClass: "btn-sign",
    on: {
      "click": function($event) {
        return _vm.regist()
      }
    }
  }, [_vm._v("注册")])])]) : _vm._e(), _vm._v(" "), (_vm.wxBand) ? _c('div', {
    staticClass: "from-box"
  }, [_c('h2', [_vm._v("绑定趣编网账号")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#424753",
      "text-align": "center",
      "line-height": "20px",
      "margin": "12px 0 35px"
    }
  }, [_vm._v("登录已有账号，与你现在登录的微信绑定。绑定后，可以使用微信账号或手机号码登录。")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.band.phone),
      expression: "band.phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.band.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.band, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "from-warning",
    class: {
      'op1': _vm.op2 === true
    }
  }, [_vm._v("*请填写正确的手机号")]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.band.code),
      expression: "band.code"
    }],
    staticClass: "yzm-ipt",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.band.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.band, "code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }],
    staticClass: "get-yzm",
    on: {
      "click": function($event) {
        return _vm.getBandYzm2()
      }
    }
  }, [_vm._v(_vm._s(_vm.yzm3))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show3),
      expression: "!show3"
    }],
    staticClass: "get-yzm"
  }, [_vm._v(_vm._s(_vm.count3) + "s")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "20px 0 20px 0"
    }
  }, [_c('button', {
    staticClass: "btn-sign",
    on: {
      "click": function($event) {
        return _vm.goBand()
      }
    }
  }, [_vm._v("绑定")])])]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.regList), function(item, index) {
    return (_vm.cur !== index) ? _c('li', {
      class: {
        'li-active': _vm.cur === index
      },
      staticStyle: {
        "font-size": "16px"
      },
      on: {
        "click": function($event) {
          return _vm.liClick(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('ul', {
    staticStyle: {
      "width": "484px",
      "margin": "155px auto 0"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logo_bak.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "32px",
      "line-height": "90px",
      "font-size": "64px",
      "color": "#FFFFFF",
      "letter-spacing": "5.12px"
    }
  }, [_vm._v("打造视频梦工厂")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "15px",
      "line-height": "50px",
      "font-size": "36px",
      "color": "#FFFFFF",
      "letter-spacing": "4.8px"
    }
  }, [_vm._v("懂视频·更懂你")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "40px 0"
    }
  }, [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "170px",
      "margin": "0 auto"
    },
    attrs: {
      "src": require("../../assets/images/logo3.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c3307b6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/register.vue
// module id = 1272
// module chunks = 45